var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-layout"},[_c('div',{staticClass:"empty-layout__content"},[_c('router-view')],1),(!_vm.$store.getters['event/isMeroPlaceVisible'])?_c('AppMeroPlace'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }